import { Box, BoxProps, Button, ButtonProps } from "@mui/material";
import { msgState, SCancelButton, SNormalButton } from "components";
import { SDialog, SDialogProps, SInputProps } from "components/parts";
import { labels } from "messages/labels";
import { useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState } from "states/focusState";

/**
 * ボタン
 */

/**
 * プロパティ
 */
export type SButtonProps = Partial<ButtonProps> &
  Pick<SInputProps, "focusId" | "label" | "index" | "disabled" | "align"> &
  Partial<Pick<SDialogProps, "dialog" | "handleSubmit">> &
  Pick<BoxProps, "gridColumn" | "gridRow"> &
  Partial<{
    dialogAction: "confirm" | "close";
  }>;

/**
 * ボタン
 * @param props
 * @returns JSX.Element
 */
export const SButton = ({
  focusId,
  index,
  dialog,
  handleSubmit: submit,
  dialogAction,
  gridColumn,
  gridRow,
  align,
  ...props
}: SButtonProps): JSX.Element => {
  // フォーカス設定
  const { focusRef, move } = useRecoilValue(focusState(focusId ?? ""));

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const handleSubmit = (data: any) => {
    submit?.call(this, data);
    setOpen(false);
  };

  // エラーメッセージ設定
  const setMsg = useSetRecoilState(msgState);

  let action = <></>;
  switch (dialogAction) {
    case "confirm":
      action = (
        <>
          <SCancelButton label={labels.buttons.cancel} onClick={handleClose} />
          <SNormalButton label={labels.buttons.ok} onClick={handleSubmit} />
        </>
      );
      break;
    case "close":
      action = (
        <SCancelButton label={labels.buttons.close} onClick={handleClose} />
      );
      break;
    default:
      action = (
        <SCancelButton label={labels.buttons.close} onClick={handleClose} />
      );
      break;
  }

  return (
    <>
      <Box gridColumn={gridColumn} gridRow={gridRow}>
        <Box display="flex" justifyContent={align}>
          <Button
            {...props}
            ref={(element) => {
              focusRef(index, element);
            }}
            onKeyDown={(event) => {
              if (!event.shiftKey && event.key === "Enter") {
                event.preventDefault();
                event.currentTarget.click();
                props.onKeyDown?.call(this, event);
              } else {
                props.onKeyDown?.call(this, event);
                move(index, event);
              }
            }}
            onClick={(event) => {
              setMsg("");
              props.onClick?.call(this, event);
              handleOpen();
            }}
            tabIndex={index ?? -1}
            variant="contained"
            size="small"
          >
            {props.label}
          </Button>
        </Box>
      </Box>
      {typeof dialog !== "undefined" && (
        <SDialog
          open={open}
          dialog={dialog}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          action={action}
        />
      )}
    </>
  );
};
